import { ReactComponent as FolderIcon } from 'img/icons/uploadFolder.svg';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { PromoSelectors } from 'reactApp/modules/promo/promo.selectors';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { Bubble } from 'reactApp/ui/Bubble/Bubble';
import { Button } from 'reactApp/ui/Button/Button';

import styles from './PublicUploadHeader.css';

interface IProps {
    firstName: string;
    lastName: string;
    nick: string;
    avatar: string;
    email: string;
    ownerEmail: string;
    showBubble: boolean;
    onUploadClick();
    onBubbleShow();
}

export const PublicUploadHeader: React.FC<IProps> = ({ firstName, lastName, nick, avatar, ownerEmail, onUploadClick }) => {
    const publicUploadPromo = useSelector(PromoSelectors.getPromo(EPromoType.publicUpload));

    useEffect(() => {
        if (publicUploadPromo) {
            publicUploadPromo.onShow();
        }
    }, [publicUploadPromo]);

    const name = `${firstName ? firstName : ''} ${lastName ? lastName : ''}`.trim() || nick || ownerEmail;

    return (
        <div className={styles.root}>
            <div className={styles.content}>
                <div className={styles.avatar} style={{ backgroundImage: `url(${avatar})` }} />
                {!!name && (
                    <div>
                        <div className={styles.name}>{name}</div>
                        <div className={styles.text}>сделал эту папку общей и разрешил загружать в нее файлы</div>
                    </div>
                )}
                <div className={styles.button}>
                    <Bubble
                        title="Загружайте файлы вместе"
                        text="В папку может грузить файлы любой, у кого есть&nbsp;ссылка"
                        isOpen={!!publicUploadPromo}
                        icon={<FolderIcon width={42} height={40} />}
                        onClose={publicUploadPromo?.onClose}
                    >
                        <div>
                            <Button primary size="big" onClick={onUploadClick} theme="octavius">
                                Загрузить файлы
                            </Button>
                        </div>
                    </Bubble>
                </div>
            </div>
        </div>
    );
};
